const stateOptions = [
  {
    name: "Riverton",
    value: false 
  }, 
  {
    name: "Sandy",
    value: false 
  }, 
  {
    name: "Herriman",
    value: false 
  }, 
]


export default stateOptions;



/** WEBPACK FOOTER **
 ** ./src/forms/options/multi.js
 **/